<template>
  <el-card class="box-card" shadow="always">
    <div class="title_btn">
      <div>*使用场景</div>
      <el-button type="primary" @click="addNum">添加</el-button>
    </div>

    <div class="banner_list">
      <div class="list">
        <div class="form-item">
          <div class="title">*排列序号</div>
          <div class="title">
            标题+图片
            <div class="el-upload__tip">(建议尺寸为510*390)</div>
          </div>
          <div class="title">*文字描述</div>
        </div>

        <div v-for="index in num" :key="index" class="form-item co_m">
          <el-input-number
            v-model="scenarios_item[index - 1].sort"
            :min="1"
            clearable
            class="name-input"
            placeholder="请输入排列序号"
          ></el-input-number>
          <div class="title_img name-input">
            <el-input
              v-model="scenarios_item[index - 1].title"
              clearable
              class="name-input market"
              placeholder="多元化营销方式："
            />
            <imageUpload v-model="scenarios_item[index - 1].img_list" :limit="1" />
          </div>
          <el-input
            v-model="scenarios_item[index - 1].dec"
            type="textarea"
            :autosize="{ minRows: 3, minCols: 20 }"
            clearable
            class="name-input"
            placeholder="请输入文字描述"
          />
          <div v-show="index != 1" class="form-item el-icon-remove" @click="delectNum(index - 1)"></div>
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
import baseURL from "@/configs/baseUrl";
import utils from "@/jslibs/utils";
import { imgDomain } from "@/configs/env";
import imageUpload from "@/components/ImageUpload";
export default {
  components: {
    imageUpload,
  },
  data() {
    return {
      num: 1,
      imgDomain,
      headers: {
        "X-Access-Token": utils.getCookie("X-Access-Token") || "",
      },
      baseURL,
      loading: false,
      sceneInfo: {},
      scenarios_item: [{ title: "", image: "", dec: "", sort: "", img_list: [] }],
    };
  },

  methods: {
    addNum() {
      this.num++;
      this.scenarios_item.push({ title: "", image: "", dec: "", sort: "", img_list: [] });
    },

    delectNum(index) {
      this.num--;
      this.scenarios_item.splice(index, 1);
    },

    verifyInput() {
      if (!this.scenarios_item[0].sort) {
        this.$notify.error({ title: "请输入场景排列序号" });
        return false;
      }

      if (!this.scenarios_item[0].title) {
        this.$notify.error({ title: "请输入多元化营销标题" });
        return false;
      }

      if (!this.scenarios_item[0].img_list.length) {
        this.$notify.error({ title: "请上传场景图片" });
        return false;
      }
      if (!this.scenarios_item[0].dec) {
        this.$notify.error({ title: "请上传场景描述" });
        return false;
      }
      this.scenarios_item.forEach((item, index) => {
        item.image = item.img_list.join();
      });
      const scenarios_item = this.scenarios_item.filter((item, index) => {
        return item.sort && item.title && item.image && item.dec;
      });
      this.sceneInfo.scenarios_item = scenarios_item;
      return true;
    },
  },
};
</script>
<style lang="less" scoped>
.title_btn {
  div {
    margin-bottom: 20px;
  }
  button {
    margin-bottom: 20px;
  }
}
.banner_list {
  border: 1px solid #ccc;
  padding: 20px;
  .list {
    .form-item {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      margin-left: 0;
      margin-bottom: 10px;
      .title {
        width: 240px;
        text-align: center;
        margin-right: 50px;
      }
      /deep/ .dankal-image-upload {
        .add-box {
          width: 40px;
          height: 40px;
          margin: 0 auto;
          padding-left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 36px;
            height: 36px;
          }
        }
        p {
          width: 40px;
          height: 40px;
          margin: 0 auto;
        }
      }
      .el-icon-remove {
        font-size: 40px;
        display: flex;
        align-items: center;
      }

      .name-input {
        width: 250px;
        margin-right: 50px;
      }
      .market {
        margin-right: 0;
        border-right: 1px solid #8b9cac;
        /deep/input {
          border: none;
        }
      }
      .el-icon-remove {
        font-size: 40px;
        display: flex;
        align-items: center;
      }
      .el-textarea {
        width: 250px;
        margin-right: 0;
      }

      .title_img {
        display: flex;
        margin-right: 50px;
        border: 1px solid #8b9cac;
        border-radius: 2px;
      }
      .img_list {
        display: flex;
        justify-content: center;
        align-items: center;
        /deep/.el-upload {
          width: 40px;
          height: 40px;
          line-height: 50px;
          border: none;
          img {
            width: 100%;
          }
        }
      }
    }
  }
}
.el-upload__tip {
  color: red;
}
</style>
